/* Coupon savings on the card (snippets/card-coupon-savings.liquid): when another weight is
   picked, the same coupon percentage of its price, in the shopper's own currency. */
function updateCouponSavings(card, variant, formatMoney) {
  const note = card?.querySelector(".card-coupon-savings[data-coupon-percent]");
  if (!note || !variant) return;
  const percent = Number(note.dataset.couponPercent) || 0;
  const price = Number(variant.price) || 0;
  if (!percent || !price) {
    note.hidden = true;
    return;
  }
  const saving = Math.round((price * percent) / 100);
  const savingEl = note.querySelector("[data-coupon-saving]");
  const finalEl = note.querySelector("[data-coupon-final]");
  if (savingEl) savingEl.textContent = formatMoney(saving);
  if (finalEl) {
    // Indian rupees: a whole number with the ₹ sign (₹339), as the snippet prints it
    // No currency code after the price (RM296.65, not RM296.65 MYR), as in the snippet
    const code = window.Shopify?.currency?.active || "";
    finalEl.textContent = note.dataset.couponWhole === "inr"
      ? "₹" + Math.round((price - saving) / 100).toLocaleString("en-US")
      : String(formatMoney(price - saving)).replace(code ? new RegExp("\\s*" + code + "\\s*$") : /$^/, "").trim();
    // the line's new size, so it still fits on one line (theme.css --cs-units, as in the snippet)
    note.style.setProperty("--cs-units", (5.8 + 0.623 * finalEl.textContent.length).toFixed(3));
  }
  // the line's new length, so it still fits on one line (theme.css --cs-chars)
  const saveLine = note.querySelector(".card-coupon-savings__save");
  if (saveLine) note.style.setProperty("--cs-chars", saveLine.textContent.length);
  note.hidden = false;
}

function initVariantPicker() {
  document
    .querySelectorAll("variant-selects:not([data-variant-init])")
    .forEach((variantSelectWrapper) => {
      const select = variantSelectWrapper.querySelector("select");
      const formId = select?.getAttribute("form");
      const closestCard = variantSelectWrapper.closest(
        ".product-card-wrapper, .card-wrapper, .product"
      );
      const form = closestCard?.querySelector(`#${formId}`);
      const priceWrapper = closestCard?.querySelector(
        ".card__product__price__cstm"
      );
      const hiddenInput = form?.querySelector('input[name="id"]');
      const submitButton = form?.querySelector('[type="submit"]');
      const variantDataScript = variantSelectWrapper.querySelector(
        'script[type="application/json"]'
      );

      if (
        !select ||
        !form ||
        !hiddenInput ||
        !variantDataScript ||
        !priceWrapper ||
        !submitButton
      )
        return;

      const variantData = JSON.parse(variantDataScript.textContent);

      // snapshot original image state at init
      const mainImage = closestCard?.querySelector(".product-first-image img");
      const originalSrc    = mainImage?.src    ?? null;
      const originalSrcset = mainImage?.srcset ?? null;
      const originalAlt    = mainImage?.alt    ?? null;

      function hideVariantError(formEl) {
        const wrapper = formEl.closest("product-form")?.querySelector(".product-form__error-message-wrapper");
        if (!wrapper) return;
        wrapper.setAttribute("hidden", "");
        wrapper.querySelector(".product-form__error-message")?.replaceChildren?.();
      }

      function formatMoney(amount) {
        const symEl = document.querySelector(".js-currency-symbol");
        const sampEl = document.querySelector(".js-currency-sample");

        const template = symEl?.dataset.priceSymbol || "₹0.00";
        const sample   = sampEl?.dataset.priceSample   || "1,234.56";

        const decMatch = template.match(/0([.,])(0{1,3})/);
        const decimalCount = decMatch ? decMatch[2].length : 0;
        const decimalSep   = decMatch ? decMatch[1] : null;

        const zeroPos = template.indexOf("0");
        const prefix  = zeroPos > -1 ? template.slice(0, zeroPos) : "";
        const theSuffix = zeroPos > -1 ? template.slice(zeroPos).replace(/0([.,]0{1,3})?/, "") : "";

        let sampleCore = sample;
        if (prefix) sampleCore = sampleCore.replace(prefix, "");
        if (theSuffix) sampleCore = sampleCore.replace(theSuffix, "");
        sampleCore = sampleCore.trim();

        if (decimalCount && decimalSep) {
          const decRegex = new RegExp(`\\${decimalSep}\\d{${decimalCount}}$`);
          sampleCore = sampleCore.replace(decRegex, "");
        }

        const grpMatch = sampleCore.replace(/\d/g, "");
        const groupSep = grpMatch ? grpMatch[0] : "";

        const cents = Math.round(Number(amount) || 0);
        let intStr, fracStr = "";

        if (decimalCount > 0) {
          const base = (cents / 100).toFixed(decimalCount);
          const parts = base.split(".");
          intStr  = parts[0];
          fracStr = parts[1] || "";
        } else {
          intStr = String(Math.round(cents / 100));
        }

        if (groupSep) {
          intStr = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
        }

        const numberStr = decimalCount > 0 ? (intStr + decimalSep + fracStr) : intStr;

        return `${prefix}${numberStr}${theSuffix}`;
      }

      function updateVariantImage(variant) {
        if (!mainImage) return;

        if (!variant?.featured_image) {
          // restore original
          if (originalSrc)    mainImage.src    = originalSrc;
          if (originalSrcset) mainImage.srcset = originalSrcset;
          if (originalAlt)    mainImage.alt    = originalAlt;
          return;
        }

        const baseSrc  = variant.featured_image.src || "";
        const cleanSrc = baseSrc.split("?")[0];
        const version  = baseSrc.match(/[?&]v=(\d+)/)?.[1] || "";
        const vParam   = version ? `v=${version}` : "";

        const widths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2160];
        const srcset = widths
          .map((w) => `${cleanSrc}?${vParam}&width=${w} ${w}w`)
          .join(", ");

        mainImage.src    = `${cleanSrc}?crop=center&height=1080&width=1080&${vParam}`;
        mainImage.srcset = srcset;
        mainImage.alt    = variant.featured_image.alt || variant.title || originalAlt || "";
      }

      hideVariantError(form);

      select.addEventListener("change", function () {
        const matchedVariant = variantData.find((v) => v.option1 === this.value);
        if (!matchedVariant) return;

        hideVariantError(form);
        submitButton.disabled = true;

        hiddenInput.value = matchedVariant.id;
        hiddenInput.removeAttribute("disabled");

        updateVariantImage(matchedVariant);

        const priceHTML = `
          <div class="price ${matchedVariant.compare_at_price > matchedVariant.price ? "price--on-sale" : ""}">
            <div class="price__container">
              <div class="price__regular">
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                <span class="price-item price-item--regular">
                  ${formatMoney(matchedVariant.price)}
                </span>
              </div>
              ${matchedVariant.compare_at_price > matchedVariant.price ? `
                <div class="price__sale">
                  <span class="visually-hidden visually-hidden--inline">Sale price</span>
                  <span class="price-item price-item--sale price-item--last">
                    ${formatMoney(matchedVariant.price)}
                  </span>
                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  <span>
                    <s class="price-item price-item--regular product-page-compare-price cstm-compare-price">
                      ${formatMoney(matchedVariant.compare_at_price)}
                    </s>
                  </span>
                  <span class="price__discount">-${Math.round(((matchedVariant.compare_at_price - matchedVariant.price) * 100) / matchedVariant.compare_at_price)}%</span>
                </div>
              ` : ""}
              <small class="unit-price caption hidden">
                <span class="visually-hidden">Unit price</span>
                <span class="price-item price-item--last">
                  <span></span>
                  <span aria-hidden="true">/</span>
                  <span class="visually-hidden"> per </span>
                  <span></span>
                </span>
              </small>
            </div>
          </div>
        `;
        priceWrapper.innerHTML = priceHTML;
        updateCouponSavings(closestCard, matchedVariant, formatMoney);

        requestAnimationFrame(() => {
          setTimeout(() => {
            if (matchedVariant.available) {
              submitButton.disabled = false;
              submitButton.removeAttribute("data-out-of-stock");
              hideVariantError(form);
            } else {
              submitButton.disabled = true;
              submitButton.setAttribute("data-out-of-stock", "true");
            }
          }, 200);
        });
      });

      form.addEventListener("submit", (e) => {
        const matchedVariant = variantData.find((v) => v.id == hiddenInput?.value);

        const errorWrapper = form.closest("product-form")?.querySelector(".product-form__error-message-wrapper");
        const errorMessage = errorWrapper?.querySelector(".product-form__error-message");

        if (!matchedVariant || !matchedVariant.available) {
          e.preventDefault();
          const productTitle =
            form.closest(".product-card-wrapper, .card-wrapper, .product")
              ?.querySelector(".card__heading, .product-title")
              ?.innerText?.trim() || "This product";
          if (errorWrapper && errorMessage) {
            errorMessage.textContent = `${productTitle} ${matchedVariant?.title || ""} is out of stock.`;
            errorWrapper.removeAttribute("hidden");
          }
        } else {
          if (errorWrapper) errorWrapper.setAttribute("hidden", "");
        }
      });

      variantSelectWrapper.setAttribute("data-variant-init", "true");
    });

  window.addEventListener("pageshow", () => {
    requestAnimationFrame(() => {
      setTimeout(() => {
        document
          .querySelectorAll("variant-selects[data-variant-init]")
          .forEach((variantSelectWrapper) => {
            const select = variantSelectWrapper.querySelector("select");
            const formId = select?.getAttribute("form");
            const closestCard = variantSelectWrapper.closest(
              ".product-card-wrapper, .card-wrapper, .product"
            );
            const form = closestCard?.querySelector(`#${formId}`);
            const priceWrapper = closestCard?.querySelector(".card__product__price__cstm");
            const hiddenInput = form?.querySelector('input[name="id"]');
            const submitButton = form?.querySelector('[type="submit"]');
            const variantDataScript = variantSelectWrapper.querySelector('script[type="application/json"]');

            if (!select || !form || !hiddenInput || !variantDataScript || !priceWrapper || !submitButton) return;

            const variantData = JSON.parse(variantDataScript.textContent);
            const mainImage = closestCard?.querySelector(".product-first-image img");

            function formatMoney(amount) {
              const symEl = document.querySelector(".js-currency-symbol");
              const sampEl = document.querySelector(".js-currency-sample");

              const template = symEl?.dataset.priceSymbol || "₹0.00";
              const sample   = sampEl?.dataset.priceSample || "1,234.56";

              const decMatch = template.match(/0([.,])(0{1,3})/);
              const decimalCount = decMatch ? decMatch[2].length : 0;
              const decimalSep   = decMatch ? decMatch[1] : null;

              const zeroPos  = template.indexOf("0");
              const prefix   = zeroPos > -1 ? template.slice(0, zeroPos) : "";
              const theSuffix = zeroPos > -1 ? template.slice(zeroPos).replace(/0([.,]0{1,3})?/, "") : "";

              let sampleCore = sample;
              if (prefix) sampleCore = sampleCore.replace(prefix, "");
              if (theSuffix) sampleCore = sampleCore.replace(theSuffix, "");
              sampleCore = sampleCore.trim();

              if (decimalCount && decimalSep) {
                const decRegex = new RegExp(`\\${decimalSep}\\d{${decimalCount}}$`);
                sampleCore = sampleCore.replace(decRegex, "");
              }

              const grpMatch = sampleCore.replace(/\d/g, "");
              const groupSep = grpMatch ? grpMatch[0] : "";

              const cents = Math.round(Number(amount) || 0);
              let intStr, fracStr = "";

              if (decimalCount > 0) {
                const base = (cents / 100).toFixed(decimalCount);
                const parts = base.split(".");
                intStr  = parts[0];
                fracStr = parts[1] || "";
              } else {
                intStr = String(Math.round(cents / 100));
              }

              if (groupSep) {
                intStr = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
              }

              const numberStr = decimalCount > 0 ? (intStr + decimalSep + fracStr) : intStr;
              return `${prefix}${numberStr}${theSuffix}`;
            }

            function updateVariantImage(variant) {
              if (!mainImage || !variant?.featured_image) return;

              const baseSrc  = variant.featured_image.src || "";
              const cleanSrc = baseSrc.split("?")[0];
              const version  = baseSrc.match(/[?&]v=(\d+)/)?.[1] || "";
              const vParam   = version ? `v=${version}` : "";

              const widths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2160];
              const srcset = widths
                .map((w) => `${cleanSrc}?${vParam}&width=${w} ${w}w`)
                .join(", ");

              mainImage.src    = `${cleanSrc}?crop=center&height=1080&width=1080&${vParam}`;
              mainImage.srcset = srcset;
              mainImage.alt    = variant.featured_image.alt || variant.title || "";
            }

            const matchedVariant = variantData.find((v) => v.option1 === select.value);
            if (!matchedVariant) return;

            hiddenInput.value = matchedVariant.id;
            hiddenInput.removeAttribute("disabled");

            updateVariantImage(matchedVariant);

            const priceHTML = `
              <div class="price ${matchedVariant.compare_at_price > matchedVariant.price ? "price--on-sale" : ""}">
                <div class="price__container">
                  <div class="price__regular">
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <span class="price-item price-item--regular">
                      ${formatMoney(matchedVariant.price)}
                    </span>
                  </div>
                  ${matchedVariant.compare_at_price > matchedVariant.price ? `
                    <div class="price__sale">
                      <span class="visually-hidden visually-hidden--inline">Sale price</span>
                      <span class="price-item price-item--sale price-item--last">
                        ${formatMoney(matchedVariant.price)}
                      </span>
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                      <span>
                        <s class="price-item price-item--regular product-page-compare-price cstm-compare-price">
                          ${formatMoney(matchedVariant.compare_at_price)}
                        </s>
                      </span>
                      <span class="price__discount">-${Math.round(((matchedVariant.compare_at_price - matchedVariant.price) * 100) / matchedVariant.compare_at_price)}%</span>
                    </div>
                  ` : ""}
                  <small class="unit-price caption hidden">
                    <span class="visually-hidden">Unit price</span>
                    <span class="price-item price-item--last">
                      <span></span>
                      <span aria-hidden="true">/</span>
                      <span class="visually-hidden"> per </span>
                      <span></span>
                    </span>
                  </small>
                </div>
              </div>
            `;
            priceWrapper.innerHTML = priceHTML;
            updateCouponSavings(closestCard, matchedVariant, formatMoney);

            if (matchedVariant.available) {
              submitButton.disabled = false;
              submitButton.removeAttribute("data-out-of-stock");
            } else {
              submitButton.disabled = true;
              submitButton.setAttribute("data-out-of-stock", "true");
            }
          });
      }, 100);
    });
  });
}